/**
 * Initializes the simplified mobile menu.
 */
export const initMobileMenuOffcanvas = (): void => {
  const toggleBtn = document.querySelector<HTMLButtonElement>(
    ".mobile-menu-toggle",
  );
  const panel = document.querySelector<HTMLElement>(".mobile-menu-panel");
  const body = document.body;

  if (!toggleBtn || !panel) return;

  const toggleMenu = () => {
    const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";
    const newState = !isExpanded;

    toggleBtn.setAttribute("aria-expanded", String(newState));
    panel.classList.toggle("is-open", newState);
    body.style.overflow = newState ? "hidden" : "";
  };

  // 1. Toggle Button Click
  toggleBtn.addEventListener("click", toggleMenu);

  // 2. Submenu Toggles (MobileNavWalker logic)
  // Logic: Clicking the toggle button (Chevron) inside the menu
  const submenuToggles = panel.querySelectorAll<HTMLButtonElement>(
    ".mobile-menu-offcanvas__submenu-toggle",
  );

  submenuToggles.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const parentItem = btn.closest("li");
      if (parentItem) {
        parentItem.classList.toggle("is-open");
        const isExpanded = parentItem.classList.contains("is-open");
        btn.setAttribute("aria-expanded", String(isExpanded));

        // Rotate chevron
        const icon = btn.querySelector(".icon");
        if (icon) {
          icon.setAttribute(
            "style",
            isExpanded
              ? "transform: rotate(180deg)"
              : "transform: rotate(0deg)",
          );
        }
      }
    });
  });

  console.log("[MobileMenu] Initialized (Simple).");
};
